module.exports = __webpack_public_path__ + "04_veryshort_brown.74be897f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_veryshort_brown.png
// module id = nfUg
// module chunks = 0